/* eslint-disable no-use-before-define */
import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

class PriorityPicker extends Component {

  render() {
    const {prioritys = ['High', 'Medium', 'Low'], label = 'Choose Priority', onChange = ()=>{}}= this.props
    return (
      <Autocomplete
        id="priority"
        options={prioritys}
        onChange={(event, newValue) => {
          if (newValue) {
            onChange(newValue);
          }
        }}
        defaultValue="Medium"
        getOptionLabel={(option) => option}
        renderInput={(params) => <TextField {...params} label={label} variant="standard" />}
      />
    );
  }
}


export default PriorityPicker